import React from "react";
import { inject, observer } from "mobx-react";
import { RouteComponentProps } from "react-router";

import { Formik, Field, FormikProps, FieldProps } from "formik";
import { TextField, Grid } from "@material-ui/core";
import { STForm, STButton, STCompleteButtonGrid, STText, STHeader } from "./styles";
import { IAuthStore } from "Stores/Auth/types";
import { IValuesStore } from "Stores/Values/types";
import { Values } from "Tools/Values";
import { required } from "Tools/FormValidations";
import { IManagementStore } from "@src/Stores/Management/types";
import { RouterStore } from "mobx-react-router";
import qs from "query-string";
import { observable } from "mobx";
import { IAuthRequestOptions } from "../../../../Interfaces/AuthRequest";

interface IOutputParams {
  subjectid?: string;
  oauthproviderid?: string;
  locationid?: string;
  externaluse?: boolean;
}

interface IProps extends RouteComponentProps {
  auth?: IAuthStore;
  values?: IValuesStore;
  management?: IManagementStore;
  routing?: RouterStore;
}
export interface IFormFields {
  login: string;
  password: string;
}

@inject("auth", "values", "routing", "management")
@observer
class LogIn extends React.Component<IProps> {
  @observable queryLowerCased: IOutputParams = {};

  componentDidMount() {
    const queryString: IOutputParams = (qs.parse(this.props.location.search) as unknown) as IOutputParams;
    Object.entries(queryString).map(([key, value]) => {
      return (this.queryLowerCased[key.toLowerCase()] = value);
    });
    window.history.pushState("LogIn", "CompleteAccountLink", "/CompleteAccountLink");
  }

  handleSubmit = async (values: IFormFields) => {
    const { auth, routing, management } = this.props;
      try {
          let options: IAuthRequestOptions = {
              name: values.login,
              password: values.password,
              location: this.queryLowerCased.locationid
          }
            if (this.queryLowerCased.externaluse == true) {
                await this.props.auth.signInViaOAuth2(options, routing.location.search, true);
            } else {
                const result = await auth.signIn(values.login, values.password, this.queryLowerCased.locationid);
                if (result.isAuthenticated) {
                    management.addAssociatedAccount(
                        this.queryLowerCased.oauthproviderid,
                        auth.personId,
                        this.queryLowerCased.subjectid
                    );
                    if (this.props.auth.afterAuthRedirectUrl) {
                      window.location.href = this.props.auth.afterAuthRedirectUrl;
                    }
                    if (this.queryLowerCased.locationid) {
                        localStorage.setItem("lastLocation", this.queryLowerCased.locationid);
                    }
                    routing.history.push("/");
                } else {
                    routing.history.push("/login");
                }
            }
    } catch (error) {
        console.error(error);
    }
  };

  handleCancel = () => {
    this.props.routing.history.push("/login");
  };

  render() {
    return (
      <>
        <Formik
          ref="form"
          onSubmit={this.handleSubmit}
          initialValues={{
            login: "",
            password: "",
          }}
          render={(formikProps: FormikProps<IFormFields>) => (
            <STForm onSubmit={formikProps.handleSubmit}>
              <STHeader>{Values.getLocalizationValue("completeAccountLink")}</STHeader>
              <STText>{Values.getLocalizationValue("accountNotLinkedWithUser")}</STText>

              <Field
                name="login"
                validate={required}
                render={({ field }: FieldProps) => (
                  <TextField
                    {...field}
                    fullWidth
                    label={Values.getLocalizationValue("username")}
                    error={formikProps.touched.login && !!formikProps.errors.login}
                    helperText={formikProps.touched.login && formikProps.errors.login}
                    inputProps={{
                      autoCapitalize: "off",
                      autoCorrect: "off",
                    }}
                  />
                )}
              />
              <Field
                name="password"
                validate={required}
                render={({ field }: FieldProps) => (
                  <TextField
                    {...field}
                    fullWidth
                    label={Values.getLocalizationValue("password")}
                    type="password"
                    error={formikProps.touched.password && !!formikProps.errors.password}
                    helperText={formikProps.touched.password && formikProps.errors.password}
                  />
                )}
              />
              <Grid container>
                <Grid item xs={6}>
                  <STButton variant="contained" onClick={this.handleCancel}>
                    {Values.getLocalizationValue("cancel")}
                  </STButton>
                </Grid>
                <STCompleteButtonGrid item xs={6}>
                  <STButton type="submit" variant="contained" color="primary">
                    {Values.getLocalizationValue("complete")}
                  </STButton>
                </STCompleteButtonGrid>
              </Grid>
            </STForm>
          )}
        />
      </>
    );
  }
}

export default LogIn;
